import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Alert, AlertType } from '../../models/alert';
import { AlertService } from '../../services/alert.service';



@Component({ 
    selector: 'alert',
    templateUrl: 'alert.component.html'
})

export class AlertComponent {
    alerts: Alert[] = [];

    constructor(private alertService: AlertService, private cdr: ChangeDetectorRef) { }

    ngOnInit() {
        this.alertService.getAlert().subscribe((alert: Alert) => {
            if (!alert) {
                // clear alerts when an empty alert is received
                this.alerts = [];
                return;
            }

            // add alert to array
            if (alert?.message) {
                this.alerts = [];
               this.alerts.push(alert);
               /*setTimeout(() => {
                this.removeAlert(this.alerts[0]);
                this.cdr.detectChanges()
               }, 10000);*/
            }
        });
        this.alertService.clearAlert.subscribe(x=>{
            if(x == true) {
                this.alerts = [];
            }
        })
    }

    removeAlert(alert: Alert) {
        this.alerts = this.alerts.filter(x => x !== alert);
    }

    cssClass(alert: Alert) {
        if (!alert) {
            return;
        }

        // return css class based on alert type
        switch (alert.type) {
            case AlertType.Success:
                return 'alert alert-success fade show';
            case AlertType.Error:
                return 'alert alert-danger fade show';
            case AlertType.Info:
                return 'alert alert-info fade show';
            case AlertType.Warning:
                return 'alert alert-warning fade show';
            // default:
            //     return;
        }
    }
}